module.exports = __webpack_public_path__ + "static/media/giant-slalom.0b28f289.png";